import type { UpdateProfileInput } from '@crm/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AUTH_QUERY_KEYS } from '../constants';
import type { ChangePasswordFormValues } from '../schemas';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/** Atualiza os dados pessoais do usuario logado. */
export function useUpdateProfile() {
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (input: UpdateProfileInput) => authService.updateProfile(input),
    onSuccess: async (user) => {
      setUser(user);
      await queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEYS.me });
    },
  });
}

/** Altera a senha do usuario logado. */
export function useChangePassword() {
  return useMutation({
    mutationFn: (values: ChangePasswordFormValues) =>
      authService.changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      }),
  });
}

/** Catalogo de permissoes: matriz por perfil + acesso efetivo do usuario. */
export function usePermissionsCatalog() {
  return useQuery({
    queryKey: AUTH_QUERY_KEYS.permissions,
    queryFn: () => authService.permissions(),
    staleTime: 5 * 60_000,
  });
}
